var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/key-square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "key-square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z",
    stroke: "#57486D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.2802 13.6101C15.1502 14.7401 13.5302 15.0901 12.1002 14.6401L9.5102 17.2201C9.3302 17.4101 8.9602 17.5301 8.6902 17.4901L7.4902 17.3301C7.0902 17.2801 6.7302 16.9001 6.6702 16.5101L6.5102 15.3101C6.4702 15.0501 6.6002 14.6801 6.7802 14.4901L9.3602 11.9101C8.9202 10.4801 9.2602 8.86014 10.3902 7.73014C12.0102 6.11014 14.6502 6.11014 16.2802 7.73014C17.9002 9.34014 17.9002 11.9801 16.2802 13.6101Z",
    stroke: "#57486D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.4496 16.2799L9.59961 15.4199",
    stroke: "#57486D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.3949 10.7002H13.4039",
    stroke: "#57486D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardPin);
export default __webpack_public_path__ + "static/media/card-pin.862e0dcd6fc729faa59ba3a1e5ba1c49.svg";
export { ForwardRef as ReactComponent };